import { StorageService } from './../shared/services/storage.service';
import { Component, OnInit } from '@angular/core';
import { LedgerService } from "../shared/services/ledger.service";
import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection, QuerySnapshot, DocumentData } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { StorageEntry, LogEntry, LedgerEntry, SaleEntry } from '../shared/services/ledger-entry';
import { AuthService } from '../shared/services/auth.service';
import { AngularFireStorage, AngularFireStorageReference, AngularFireUploadTask } from '@angular/fire/storage';
/*
      link code and shipment then ask if we should some how add checker for quantity?
  add storage item linked to shipment and add log
?     if  already added switch to minus plus mode (Edit Mode)
!     use code to switch and apply autocomplete
*     edit mode adds log of edit (minus plus values) while add adds log of add

      cascade menu items

      total costs

      storage sense
  add storage item linked to shipment and add log
?     if  already added switch to minus plus mode (Edit Mode)
!     use code to switch and apply autocomplete
*     edit mode adds log of edit (minus plus values) while add adds log of add

*/
declare var require: any
@Component({
  selector: 'app-storage',
  templateUrl: './storage.component.html',
  styleUrls: ['./storage.component.css']
})
export class StorageComponent implements OnInit {
  ready = false;
  error: string;
  updateMode: boolean = false;
  rate: number;
  orderId: string;
  orders = {};
  saleEntry: SaleEntry = {
    user: "",
    userEmail: "",
    userNumber: "",
    userId: "",
    date: new Date(),
    buyer: "",
    buyerTaxId: "",
    buyerAddress: "",
    buyerPhone:"",
    order: [],
    approved: false,
    approvedUser: "",
    approvedUserEmail: "",
    approvedUserNumber: "",
    approvedUserId: "",
    shipped: false,
    shippedUser: "",
    shippedUserEmail: "",
    shippedUserNumber: "",
    shippedUserId: "",
    reason: "",
    downPay:0,
    ledgerEntrySale: [], ledgerEntryAR: [],ledgerEntryCost: []
  }
  constructor(
    private afStorage: AngularFireStorage,
    public authService: AuthService,
    private db: AngularFirestore,
    private db2: AngularFirestore,
    private ledgerService: LedgerService,
    private storageService: StorageService) {
    //this.ledgerService.getLedger();
  }
  ngOnInit() {


    var me = this;
    setTimeout(function () { (<HTMLInputElement>document.getElementById("init")).click(); }, 500);
    setTimeout(function () { me.getStorage(); }, 1000);// fix Latency
    setTimeout(function () { me.getLedger(); }, 500);
    this.getSale();
    // this.getStorage();
    this.setUser();
  }
  setUser() {
    this.userProfile = this.authService.getUserProfile;

    this.user = this.authService.getUser;
    this.storageEntry.user = this.userProfile.displayName;
    this.storageEntry.userEmail = this.userProfile.email;
    this.storageEntry.userNumber = this.userProfile.number;
    this.storageEntry.userId = this.user.uid;
  }
  totalRetailOrder = 0; totalQOrder = 0;
  userProfile;
  user;
  addingNew = true;
  backup = false;
  fullView = false;
  totalCashFlow: number;
  ledger: Observable<any[]>;
  storage: Observable<any[]>;
  fileReaded: any;
  safeToFilter: boolean = true;
  totalCost = 0; totalRetail = 0; totalQ = 0; totalActualCost = 0;
  totalDebit = 0; totalCredit = 0;
  myEntry: string;
  editMode: boolean = false;
  incomeStatement = { "container": [], "directCost": [], "directCostCr": [], "sales": [], "totalSales": 0, "exp": [], "taxes": [], "zero": [], "totalZero": 0, "expOp": [], "totalExpOp": 0, "expOpCr": [], "totalExpOpCr": 0, "totalTaxes": 0, "totalExp": 0, "totalContainer": 0, "totalDirectCost": 0, "totalDirectCostCr": 0, "totalCogs": 0 };
  editType;
  entryToEdit: any = {};
  autoComplete = {
    supplier: {},
    shipmentNumber: {},
    code: {},
    storageLocation: {},
    name: {},
  };
  autoCompleteKeys = {
    supplier: {},
    shipmentNumber: {},
    code: {},
    storageLocation: {},
    name: {},

  };
  autoCompleteString = JSON.stringify(this.autoComplete); autoCompleteArray = []; codeArray = [];
  storageEntry: StorageEntry = {
    id: "",
    supplier: "",
    shipmentNumber: 0,
    code: "",
    storageLocation: "",
    name: "",
    buyer: "",
    cost: 0,
    actualCost: 0,
    retailPrice: 0,
    quantity: 0,
    log: [],
    logs: [],
    user: "",
    userId: "",
    userNumber: "",
    userEmail: "",
    url:"",
  }
  downloadURL: Observable<string>;
  uploadProgress: Observable<number>;
  ref: AngularFireStorageReference;
  task: AngularFireUploadTask;
  // LedgerEntrySale = {

  //   creditValue: 0,

  //   debitValue: 0,

  // }
  // LedgerEntryCost= {


  //   creditValue: 0,


  //   debitValue: 0,

  // }
  generalStorageCollection = { generalStorage: [] };
  disabled = true;
  show = true;
  order = { quantity: 0, };
  editOrder = false;
  event;
  upload(event) {
    this.event = event;
    this.ref = this.afStorage.ref('storage/' + this.storageEntry.supplier + '/' + this.storageEntry.name);
    this.task = this.ref.put(this.event.target.files[0]);
    this.uploadProgress = this.task.percentageChanges();
    this.task.then(() => {
      this.downloadURL = this.ref.getDownloadURL();
      console.log(this.downloadURL, 'storage/' + this.storageEntry.supplier + '/' + this.storageEntry.name, this.uploadProgress)
      this.downloadURL.subscribe(url => { this.storageEntry.url = url });
      this.event = null;
    })
    
  }
  actualCostEdit() {
  //  console.log(this.disabled);
    // this.disabled++;
    // if (this.disabled == 2) {
    //   this.disabled = 0;
    if (confirm('Are you sure you want to enter the Stock Cost manually?')) {
      let link = document.querySelector('#autocompleteactualCost');
      if (link) {
        link.removeAttribute('disabled'); this.disabled = !this.disabled;
      }
    }
    // }
  }
  addNew() {
    // if (this.addingNew) {
    //   (<HTMLInputElement>document.getElementById('addForm')).className = "col s12 m12 l12";
    //   this.addingNew = !this.addingNew;
    // } else {
    //   (<HTMLInputElement>document.getElementById('addForm')).className = "col s12 m12 l10";
    //   this.addingNew = !this.addingNew;

    // }
  }
  showBackup() {
    this.backup = !this.backup;
  }
  getFullView() {
    this.fullView = !this.fullView;
  }

  roundValue(value) {
    return Math.round((value + Number.EPSILON) * 100) / 100;

  }
  getSale() {
    // console.log("calling server for ledger");
    // 
    this. storage = this.db.collection("generalSale")
      .snapshotChanges()
      .pipe(
        map(
          actions => {
            return actions.map(a => {
              //Get document data
              const data = a.payload.doc.data() as SaleEntry;
              const id = a.payload.doc.id;
              this.orders[id] = data;
              console.log(data);
              // this.addAutoComplete(data);
              // this.generalLedgerCollection.generalLedger.push(data);
              // let unix_timestamp = data.date['seconds']
              // var date = new Date(unix_timestamp * 1000); //console.log(date);
              // Math.abs(2 % 2) == 1
              //Use spread operator to add the id to the document data
              return { id, data };
            });
          }));
  }
  getLedger() {
    // console.log("calling server for ledger");
    // 
    this.storage = this.db.collection("generalLedger")
      .snapshotChanges()
      .pipe(
        map(
          actions => {
            return actions.map(a => {
              //Get document data
              const data = a.payload.doc.data() as StorageEntry;
              const id = a.payload.doc.id;
              //console.log(data);
              this.addAutoComplete(data);
              // this.generalLedgerCollection.generalLedger.push(data);
              // let unix_timestamp = data.date['seconds']
              // var date = new Date(unix_timestamp * 1000); //console.log(date);
              // Math.abs(2 % 2) == 1
              //Use spread operator to add the id to the document data
              return { id, data };
            });
          }));
  }
  getStorage() {
//TODO item pic
    this.storage = this.db2.collection("generalStorage", ref => ref.orderBy("storageLocation"))
      .snapshotChanges()
      .pipe(
        map(
          actions => {
            this.ready = true;
            this.totalCost = 0; this.totalRetail = 0; this.totalQ = 0; this.totalActualCost = 0;
            return actions.map(a => {
              //Get document data
              const data = a.payload.doc.data() as StorageEntry;
              const id = a.payload.doc.id;
              //console.log(data);
              this.totalCost += data.cost; this.totalRetail += data.retailPrice; this.totalQ += data.quantity;
              this.totalActualCost += data.actualCost;
              this.addAutoComplete(data);
              this.generalStorageCollection.generalStorage.push(data);
              this.show = true;
              // this.generalLedgerCollection.generalLedger.push(data);
              // let unix_timestamp = data.date['seconds']
              // var date = new Date(unix_timestamp * 1000); //console.log(date);
              // Math.abs(2 % 2) == 1
              //Use spread operator to add the id to the document data
              return { id, data };
            });
          }));


  }
  calculateCost(storageEntry: StorageEntry) {
    // get storage shipment and number then get rate .. get cogs then get provisional tax from income statement .. rate = ((cost*rate)*(cogs+tax)/(cogs)), rate*cost
    let shipmentNumber = storageEntry.shipmentNumber;
    let supplier = storageEntry.supplier;

    //console.log("filterstart");
    let db = this.db;//handle case zero ? ask dad ?
    //get container
    let collection = db.collection("generalLedger", ref => ref.where('supplier', '==', supplier).where('shipmentNumber', '==', shipmentNumber).where('codeDebit', '==', "Container"))
    collection.get().toPromise()
      .then((querySnapshot: QuerySnapshot<DocumentData>) => {
        this.incomeStatement["container"] = [];
        this.incomeStatement["totalContainer"] = 0;
        this.incomeStatement["totalCogs"] = 0;
        querySnapshot.forEach((doc: any) => {
          const data = doc.data() as LedgerEntry;
          //Get document id
          const id = doc.id;
          //console.log(data);
          this.incomeStatement["container"].push(data);
          this.incomeStatement["totalContainer"] -= data["debitValue"];
          this.incomeStatement["totalCogs"] -= data["debitValue"];
          //Use spread operator to add the id to the document data
          return { id, data };
        })
      });
    //get direct cost
    collection = db.collection("generalLedger", ref => ref.where('supplier', '==', supplier).where('shipmentNumber', '==', shipmentNumber).where('codeDebit', '==', "Direct Cost"))
    collection.get().toPromise()
      .then((querySnapshot: QuerySnapshot<DocumentData>) => {
        this.incomeStatement["directCost"] = [];
        this.incomeStatement["totalDirectCost"] = 0;
        querySnapshot.forEach((doc: any) => {
          //Get document data
          const data = doc.data() as LedgerEntry;
          //Get document id
          const id = doc.id;
          //console.log(data);
          this.incomeStatement["directCost"].push(data);
          this.incomeStatement["totalDirectCost"] -= data["debitValue"];
          this.incomeStatement["totalCogs"] -= data["debitValue"];
          //Use spread operator to add the id to the document data
          return { id, data };
        });
      });

    //get direct cost Cr
    collection = db.collection("generalLedger", ref => ref.where('supplier', '==', supplier).where('shipmentNumber', '==', shipmentNumber).where('codeCredit', '==', "Direct Cost"))
    collection.get().toPromise()
      .then((querySnapshot: QuerySnapshot<DocumentData>) => {
        this.incomeStatement["directCostCr"] = [];
        this.incomeStatement["totalDirectCostCr"] = 0;
        querySnapshot.forEach((doc: any) => {
          //Get document data
          const data = doc.data() as LedgerEntry;
          //Get document id
          const id = doc.id;
          //console.log(data);
          this.incomeStatement["directCostCr"].push(data);
          this.incomeStatement["totalDirectCostCr"] += this.roundValue(data["debitValue"]);
          this.incomeStatement["totalCogs"] += this.roundValue(data["debitValue"]);
          //Use spread operator to add the id to the document data
          return { id, data };
        });
      });





    //get Exp
    collection = db.collection("generalLedger", ref => ref.where('supplier', '==', supplier).where('shipmentNumber', '==', shipmentNumber).where('codeDebit', '==', "Exp"))
    collection.get().toPromise()
      .then((querySnapshot: QuerySnapshot<DocumentData>) => {
        this.incomeStatement["exp"] = [];
        this.incomeStatement["totalExp"] = 0;
        querySnapshot.forEach((doc: any) => {
          //Get document data
          const data = doc.data() as LedgerEntry;
          //Get document id
          const id = doc.id;
          //console.log(data);
          this.incomeStatement["exp"].push(data);
          this.incomeStatement["totalExp"] -= data["debitValue"];
          //Use spread operator to add the id to the document data
          return { id, data };
        });
      });

    //get provisional tax
    collection = db.collection("generalLedger", ref => ref.where('supplier', '==', supplier).where('shipmentNumber', '==', shipmentNumber).where('codeDebit', '==', "provisional tax"))
    collection.get().toPromise()
      .then((querySnapshot: QuerySnapshot<DocumentData>) => {
        this.incomeStatement["taxes"] = [];
        this.incomeStatement["totalTaxes"] = 0;
        querySnapshot.forEach((doc: any) => {
          //Get document data
          const data = doc.data() as LedgerEntry;
          //Get document id
          const id = doc.id;
          //console.log(data);
          this.incomeStatement["taxes"].push(data);
          this.incomeStatement["totalTaxes"] -= data["debitValue"];
          //Use spread operator to add the id to the document data
          return { id, data };
        });
      });

    //get Sales
    collection = db.collection("generalLedger", ref => ref.where('supplier', '==', supplier).where('shipmentNumber', '==', shipmentNumber).where('codeCredit', '==', "Sales"))
    collection.get().toPromise()
      .then((querySnapshot: QuerySnapshot<DocumentData>) => {
        this.incomeStatement["sales"] = [];
        this.incomeStatement["totalSales"] = 0;
        querySnapshot.forEach((doc: any) => {
          //Get document data
          const data = doc.data() as LedgerEntry;
          //Get document id
          const id = doc.id;
          //console.log(data);
          this.incomeStatement["sales"].push(data);
          this.incomeStatement["totalSales"] += this.roundValue(data["debitValue"]);
          //Use spread operator to add the id to the document data
          return { id, data };
        });
      });
    let rate = 0;
    collection = db.collection("generalShipments", ref => ref.where('supplier', '==', supplier).where('shipmentNumber', '==', shipmentNumber))
    collection.get().toPromise()
      .then((querySnapshot: QuerySnapshot<DocumentData>) => {
        querySnapshot.forEach((doc: any) => {
          //Get document data
          const data = doc.data();
          //Get document id
          const id = doc.id;
          // console.log(data.rate);
          data.rate ? rate = data.rate : null;
          //Use spread operator to add the id to the document data
          return { id, data };
        });
      });
    var me = this;
    setTimeout(function () {
      me.rate =
        ((storageEntry.cost * rate) * (me.incomeStatement.totalCogs + (-1 * me.incomeStatement.totalTaxes))
          / (me.incomeStatement.totalCogs))
      me.storageEntry.actualCost <= me.storageEntry.cost * me.rate ?
        me.storageEntry.actualCost = me.storageEntry.cost * me.rate : null;// handle rate not found set to zero
    //  console.log(storageEntry.cost, rate, me.incomeStatement.totalCogs, (-1 * me.incomeStatement.totalTaxes), me.incomeStatement.totalCogs);
    }, 500);
  }
  isToday(dateParameter) {
    var today = new Date();
  //  console.log("is today?", dateParameter.getDate() === today.getDate() && dateParameter.getMonth() === today.getMonth() && dateParameter.getFullYear() === today.getFullYear());

    return dateParameter.getDate() === today.getDate() && dateParameter.getMonth() === today.getMonth() && dateParameter.getFullYear() === today.getFullYear();
  }
  getArrayOfKeysFromObject(obj) {
    var arr = [];
    Object.keys(obj).forEach(function (key) {
      //var value = data[key];
      arr.push(key);
    });
    return arr;
  }
  addAutoComplete(data) {
    // 
    var me = this;
    Object.keys(this.autoCompleteKeys).forEach(function (key) {
      //var value = data[key];
      if (me.autoComplete[key][data[key]] != "" && data[key] != "" && data[key]) {
        me.autoComplete[key][data[key]] = "";
        me.autoCompleteArray.push(data[key]);
      }

    });
    me.autoCompleteString = JSON.stringify(me.autoComplete);
    //console.log(this.autoComplete);
  }
  updateValueOnAutocomplete() {
    let me = this;
    Object.keys(this.autoCompleteKeys).forEach(function (key) {
      let val = (<HTMLInputElement>document.getElementById('autocomplete' + key)).value;
      if (val) {
        if (key != 'shipmentNumber') {
          if (key == 'date') {
            me.storageEntry[key] = new Date(val);
          }
          else
            me.storageEntry[key] = val;
        }
        else {
          me.storageEntry[key] = Number.parseFloat(val);
        }
        //console.log(me.LedgerEntry[key]);
      }
      //
    });
  }
  // getRecordToUpdate(code) {

  // }
  filterLedgerFromServerByText(): void {
    this.updateValueOnAutocomplete();
  //  console.log("filter called");
    let keys = Object.keys(this.autoComplete.code);
    // keys.length != this.codeArray.length ? this.codeArray = keys : null;
    keys.includes(this.storageEntry.code) ? this.updateMode = true : this.updateMode = false;
    // this.updateMode ? this.getRecordToUpdate(this.storageEntry.code) : null;
    // enter edit mode
    let supplier = this.storageEntry.supplier;
    let shipmentNumber = this.storageEntry.shipmentNumber;
    let code = this.storageEntry.code;
    let name = this.storageEntry.name;
    let storageLocation = this.storageEntry.storageLocation;

  //  console.log("filter", supplier, shipmentNumber, code, name, storageLocation);
    if (supplier == "" && this.safeToFilter) {
      this.getStorage();
      if ((this.autoCompleteArray.includes(code) ||
        this.autoCompleteArray.includes(name) ||
        this.autoCompleteArray.includes(storageLocation)) &&
        this.safeToFilter) {
        //console.log("filterstart");
        let db = this.db;//handle case zero ? ask dad ?
        let collection = db.collection("generalStorage");
        if (code != "") {
          code == '0' ?
            collection = db.collection("generalStorage", ref => ref.where('cost', '==', 0)) :
            collection = db.collection("generalStorage", ref => ref.where('code', '==', code));
        }
        if (name != "") {
          collection = db.collection("generalStorage", ref => ref.where('name', '==', name))
        }
        if (storageLocation != "") {
          collection = db.collection("generalStorage", ref => ref.where('storageLocation', '==', storageLocation))
        }
        if (storageLocation != "" && name != "") {
          collection = db.collection("generalStorage", ref => ref.where('storageLocation', '==', storageLocation).where('name', '==', name))
        }
        if (storageLocation != "" && name != "" && code != "") {
          collection = db.collection("generalStorage", ref => ref.where('storageLocation', '==', storageLocation).where('name', '==', name).where('code', '==', code))
        }
        if (name != "" && code != "") {
          collection = db.collection("generalStorage", ref => ref.where('storageLocation', '==', storageLocation).where('name', '==', name).where('code', '==', code))
        }

        this.storage = collection.snapshotChanges().pipe(
          map(
            actions => {
              this.totalCost = 0; this.totalRetail = 0; this.totalQ = 0;
              return actions.map(a => {
                //Get document data
                const data = a.payload.doc.data() as StorageEntry;
                const id = a.payload.doc.id;
                this.updateMode ? this.editEntry(data, id) : null;
                this.totalCost += data.cost; this.totalRetail += data.retailPrice; this.totalQ += data.quantity;
                //console.log(data);
                //this.addAutoComplete(data)
                // this.generalLedgerCollection.generalLedger.push(data);
                // let unix_timestamp = data.date['seconds']
                // var date = new Date(unix_timestamp * 1000); //console.log(date);
                // Math.abs(2 % 2) == 1
                //Use spread operator to add the id to the document data
                return { id, data };
              });
            }));
      }
      return;
    } //console.log("filter check", this.autoCompleteArray.includes(supplier) && this.safeToFilter, this.autoCompleteArray , supplier, this.safeToFilter);
    if (this.autoCompleteArray.includes(supplier) && this.safeToFilter) {
      //console.log("filterstart");
      let db = this.db;//handle case zero ? ask dad ?
      let collection = db.collection("generalStorage");
      if (shipmentNumber == 0) {
        collection = db.collection("generalStorage", ref => ref.where('supplier', '==', supplier))
      }
      else {
        collection = db.collection("generalStorage", ref => ref.where('supplier', '==', supplier).where('shipmentNumber', '==', shipmentNumber));
        if (code != "") {

          collection = db.collection("generalStorage", ref => ref.where('supplier', '==', supplier).where('shipmentNumber', '==', shipmentNumber).where('code', '==', code))
        }
        if (code != "" && name != "") {

          collection = db.collection("generalStorage", ref => ref.where('supplier', '==', supplier).where('shipmentNumber', '==', shipmentNumber).where('code', '==', code).where('name', '==', name))
        }
        if (code != "" && storageLocation != "") {

          collection = db.collection("generalStorage", ref => ref.where('supplier', '==', supplier).where('shipmentNumber', '==', shipmentNumber).where('code', '==', code).where('storageLocation', '==', storageLocation))
        }
        if (code != "" && name != "" && storageLocation != "") {

          collection = db.collection("generalStorage", ref => ref.where('supplier', '==', supplier).where('shipmentNumber', '==', shipmentNumber).where('code', '==', code).where('name', '==', name).where('storageLocation', '==', storageLocation))
        }
        if (name != "") {
          collection = db.collection("generalStorage", ref => ref.where('supplier', '==', supplier).where('shipmentNumber', '==', shipmentNumber).where('name', '==', name))
        }
        if (storageLocation != "") {
          collection = db.collection("generalStorage", ref => ref.where('supplier', '==', supplier).where('shipmentNumber', '==', shipmentNumber).where('storageLocation', '==', storageLocation))
        }
        if (name != "" && storageLocation != "") {
          collection = db.collection("generalStorage", ref => ref.where('supplier', '==', supplier).where('shipmentNumber', '==', shipmentNumber).where('name', '==', name).where('storageLocation', '==', storageLocation))
        }


      }

      this.storage = collection.snapshotChanges().pipe(
        map(
          actions => {
            this.totalCost = 0; this.totalRetail = 0; this.totalQ = 0;
            return actions.map(a => {
              //Get document data
              const data = a.payload.doc.data() as StorageEntry;
              const id = a.payload.doc.id;
              this.updateMode ? this.editEntry(data, id) : null;
              this.totalCost += data.cost; this.totalRetail += data.retailPrice; this.totalQ += data.quantity;
              //console.log(data);
              //this.addAutoComplete(data)
              // this.generalLedgerCollection.generalLedger.push(data);
              // let unix_timestamp = data.date['seconds']
              // var date = new Date(unix_timestamp * 1000); //console.log(date);
              // Math.abs(2 % 2) == 1
              //Use spread operator to add the id to the document data
              return { id, data };
            });
          }));
    }


  }
  getOrder(code) {
    // console.log(!(this.editType != 'return') && this.getOrder(code));
    
    let res = 0;
    if (this.orders[this.orderId]) {
      let item = this.orders[this.orderId].order.filter(obj => {
        return obj.code === code
      })
      item ? res = item[0].quantity : null;
      this.saleEntry = this.orders[this.orderId];
      this.calculateOrderTotal();

    }
    this.editType == 'return' ? null : res = 1;
    return res;
   }
  editEntry(ledgerEntry, id) {
  //  console.log(ledgerEntry, id);
    //Set taskToEdit and editMode
    this.storageEntry = JSON.parse(JSON.stringify(ledgerEntry));
    window.scrollTo(0, 0);
    this.setUser();
    this.editMode = true;
    this.updateMode = true;
    this.editType = "";
    this.entryToEdit.id = id;
    this.entryToEdit.data = JSON.parse(JSON.stringify(ledgerEntry));
    setTimeout(function () { (<HTMLInputElement>document.getElementById("init")).click(); }, 500);
    //Set form value
    //this.myEntry = ledgerEntry.description;
  } //edit
  handleEdit() {
  //  console.log(this.editType, this.entryToEdit.data);
    switch (this.editType) {
      case "edit":
        this.storageEntry = JSON.parse(JSON.stringify(this.entryToEdit.data));
        break;
      case "sale":
        this.storageEntry = JSON.parse(JSON.stringify(this.entryToEdit.data));
        this.storageEntry.quantity = 0;
        break;
      case "return":
        this.storageEntry = JSON.parse(JSON.stringify(this.entryToEdit.data));
        this.storageEntry.quantity = 0;
        // this.getOrder();
        break;
      case "new":
        this.storageEntry = JSON.parse(JSON.stringify(this.entryToEdit.data));
        this.storageEntry.shipmentNumber = 0;
        break;
      default:
        // code block
        break
    }
  }
  calculateOrderTotal() {
    this.totalRetailOrder = 0; this.totalQOrder = 0;
    this.saleEntry.order.forEach(elem => {
      this.totalQOrder += elem.quantity;
      this.totalRetailOrder += elem.quantity * elem.retailPrice;
    })
  }
  updateOrder() {
    this.saleEntry = this.orders[this.orderId]//JSON.parse(JSON.stringify(this.orders[this.orderId]))
    let obj = this.saleEntry.order.findIndex(obj => {
      return obj.code === this.storageEntry.code
    })
    this.saleEntry.order[obj]['quantity'] = this.saleEntry.order[obj]['quantity'] - this.storageEntry.quantity;
    // this.saleEntry.
    this.updateLedger();

    this.storageService.updateSale(this.orderId, this.saleEntry)
  }
  updateLedger() {
    let supplierProducts = { suppliers: [], products: {} };
    this.saleEntry.order.forEach(product => {
      if (!supplierProducts.suppliers.includes(product.supplier)) {
        supplierProducts.suppliers.push(product.supplier);
        supplierProducts.products[product.supplier] = []
      };
      supplierProducts.products[product.supplier].push(product);
    });

    supplierProducts.suppliers.forEach(supplier => {
      let LedgerEntrySale = { creditValue: 0, debitValue: 0, supplier: supplier };
      // let LedgerEntryAR = { creditValue: 0, debitValue: 0, supplier: supplier };
      let LedgerEntryCost = { creditValue: 0, debitValue: 0, supplier: supplier };

      supplierProducts.products[supplier].forEach(product => {
        // sale Value= total Retail price used
        // cost Value= Total of Actual cost used in order
        LedgerEntrySale.creditValue += product.quantity * product.retailPrice;
        LedgerEntrySale.debitValue += product.quantity * product.retailPrice;
        // test auto ledger entry
        // handle return?
        LedgerEntryCost.creditValue += product.quantity * product.actualCost;
        LedgerEntryCost.debitValue += product.quantity * product.actualCost;
      })

      this.shipEntryHelper(LedgerEntryCost,LedgerEntrySale);
    })
    // this.saleEntry.ledgerEntryCost.forEach((entryId) => {

    // })
    // this.saleEntry.ledgerEntrySale.forEach((entryId) => {

    // })
  }
  shipEntryHelper(LedgerEntryCost, LedgerEntrySale) {
    // fix ledger id index aand do return
    this.ledgerService.updateTask(this.saleEntry.ledgerEntryAR.filter(obj => {
      return obj['supplier'] === LedgerEntrySale.supplier;
    })[0]['id'],LedgerEntrySale)

    this.ledgerService.updateTask(this.saleEntry.ledgerEntryCost.filter(obj => {
      return obj['supplier'] === LedgerEntrySale.supplier;
    })[0]['id'],LedgerEntryCost)
  }
  saveEntry() {
    this.setUser();
    if (this.autoCompleteArray.includes(this.storageEntry.supplier) && this.autoCompleteArray.includes(this.storageEntry.shipmentNumber) && this.storageEntry.code !== "" && this.storageEntry.name !== "") {//add storage entry checks
      //Get the input value
      //balance values
      this.error = "";
      if (!this.editMode) {
        //console.log(this.storageEntry);
        // const id = Math.random().toString(36).substring(2);

        
        this.storageService.addStorageTask(this.storageEntry);
      } else {
        // on types change value of fields
        // handle edit modes
        //Get the entry id
        let taskId = this.entryToEdit.id;
        //update the entry
        this.editType == "return" ? this.updateOrder(): null;
        this.storageService.updateStorageTask(taskId, this.storageEntry, this.editType, this.entryToEdit.data);

      }
      //set edit mode to false and clear form
      this.updateMode = false;
      this.editMode = false;
      this.editType = "";
      this.entryToEdit = {};
      this.storageEntry = {
        id: "",
        supplier: "",
        shipmentNumber: 0,
        code: "",
        storageLocation: "",
        name: "",
        buyer: "",
        cost: 0,
        actualCost: 0,
        retailPrice: 0,
        quantity: 0,
        log: [],
        logs: [],
        user: "",
        userId: "",
        userEmail: "",
        userNumber: "",
        url:"",
      }
      this.setUser();
      this.getStorage();
      this.myEntry = "";
    } else
      this.error = "Please pick a correct Supplier and shipment number";
  } //saveTask
  deleteTask(entry) {
    if (confirm('Are you sure you want to delete this item?')) {
      //Get the entry id
      let taskId = entry.id;
      // this.totalActualCost -= entry.data.actualCost;
      //delete the entry
      this.storageService.deleteStorageTask(taskId, entry.data.log);
    }
  } //deleteTask
  exportJSON() {
    var a = document.createElement("a");
    var file = new Blob([JSON.stringify(this.generalStorageCollection)], { type: 'application/json' });
    a.href = URL.createObjectURL(file);
    a.download = 'backup.json';
    a.click();
    //https://firebase.google.com/docs/firestore/manage-data/export-import
    //console.log("https://firebase.google.com/docs/firestore/manage-data/export-import");
  }
  importJSON(csv: any) {
    this.safeToFilter = false;
    this.fileReaded = csv.target.files[0];

    let reader: FileReader = new FileReader();
    reader.readAsText(this.fileReaded);
    //console.log(reader.result)
    reader.onload = (e) => {

      let result = reader.result.toString();
      let json = JSON.parse(result);
      //console.log(json)
      for (let i = 0; i < json["generalStorage"].length; i++) {

        this.storageEntry = json["generalStorage"][i];
        // Object.keys(json["generalStorage"]).forEach(function (key) {

        //   this.StorageEntry[key] = json["generalStorage"][i][key];
        // });
        //console.log(this.StorageEntry)
        this.saveEntry();
        this.storageEntry = {
          id: "",
          supplier: "",
          shipmentNumber: 0,
          code: "",
          storageLocation: "",
          name: "",
          buyer: "",
          cost: 0,
          actualCost: 0,
          retailPrice: 0,
          quantity: 0,
          log: [],
          logs: [],
          user: "",
          userId: "",
          userNumber: "",
          userEmail: "",
          url:"",
        }
        this.safeToFilter = true;
      }
    }
  }
}
